import axios from 'axios'
import { SERVER_URL } from '../config/runtimeConfig'

export const API_URL = SERVER_URL

const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,
  timeout: 540000, // 540 second timeout (9 minutes) for long operations including multi-series CT scan loading
})

// Niente interceptor di richiesta per l'autenticazione: il biglietto viaggia
// nel cookie HttpOnly che il backend ha messo al login, e `withCredentials`
// lo attacca da solo. Costruire qui un header `Authorization` vorrebbe dire
// poter leggere quel cookie da JavaScript, cioe' rinunciare a HttpOnly.

// Pagine che si aprono senza sessione, spesso da un link in una email
// (reset password, attivazione). Un 401 qui non vuol dire "sessione scaduta":
// vuol dire che l'utente non e' loggato, ed e' giusto cosi'. Rimandarlo a
// /login chiudeva la pagina del reset prima che si potesse scrivere la
// password (link dell'email -> /login, 2026-10-05).
const PUBLIC_PATHS = [
  '/',
  '/login',
  '/logout',
  '/oauth-callback',
  '/mfa-challenge',
  '/password-reset',
  '/confirm-password',
  '/signup',
  '/signup-success',
  '/activate',
  // Plans and costs: read by people without an account (ticket 6ad5d51d).
  '/costs',
]

// La sonda di sessione di UserContext: il suo 401 e' la risposta normale per
// chi non e' loggato, e a portarlo al login ci pensa PrivateRoute.
const SESSION_PROBE = '/weresp/verify_token'

const isPublicPath = (pathname) =>
  PUBLIC_PATHS.some(
    (p) => pathname === p || (p !== '/' && pathname.startsWith(`${p}/`))
  )

export const shouldRedirectToLogin = (pathname, requestUrl = '') =>
  !isPublicPath(pathname) && !String(requestUrl).endsWith(SESSION_PROBE)

$api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Il cookie non si puo' cancellare da qui (HttpOnly): a toglierlo e' il
      // backend, sul logout.
      if (
        shouldRedirectToLogin(window.location.pathname, error.config?.url)
      ) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default $api
